import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, concatMap, map, mergeMap, of } from 'rxjs';
import { OnDemandReadActions } from './on-demand-read.actions';
import { OnDemandReadApiService } from '../services/on-demand-read-api.service';
import { TimezoneService } from 'src/app/services/utility/timezone.service';

export const startOnDemandReadCalculations$ = createEffect(
  (actions$ = inject(Actions), onDemandReadApiService = inject(OnDemandReadApiService)) =>
    actions$.pipe(
      ofType(OnDemandReadActions.startOnDemandReadCalculations),
      concatMap(({ id, deviceDeviceUID, mtuDeviceUID }) =>
        onDemandReadApiService.postOnDemandReads(deviceDeviceUID).pipe(
          mergeMap(() => [
            OnDemandReadActions.setOnDemandReadPostApiInProgressStatus({
              id,
              deviceDeviceUID,
              mtuDeviceUID,
              status: false
            }),
            OnDemandReadActions.setOnDemandReadGetApiInProgressStatus({
              id,
              deviceDeviceUID,
              mtuDeviceUID,
              status: true
            })
          ]),
          catchError(() =>
            of(
              OnDemandReadActions.startOnDemandReadCalculationsFailure({
                id,
                deviceDeviceUID,
                mtuDeviceUID,
                error: 'error'
              })
            )
          )
        )
      )
    ),
  { functional: true }
);

export const loadOnDemandReads$ = createEffect(
  (
    actions$ = inject(Actions),
    onDemandReadApiService = inject(OnDemandReadApiService),
    timezoneService = inject(TimezoneService)
  ) =>
    actions$.pipe(
      ofType(OnDemandReadActions.getOnDemandReads),
      concatMap(({ id, deviceDeviceUID, mtuDeviceUID }) =>
        onDemandReadApiService.getOnDemandReads(deviceDeviceUID).pipe(
          map(onDemandReads =>
            OnDemandReadActions.getOnDemandReadsSuccess({
              onDemandReads: {
                id,
                deviceDeviceUID,
                mtuDeviceUID,
                isRequestInProgressExist: onDemandReads.isRequestInProgressExist,
                failedRead: onDemandReads.failedRead
                  ? {
                      ...onDemandReads.failedRead,
                      dateUtc: timezoneService.formatLong(onDemandReads.failedRead!.dateUtc)
                    }
                  : null,
                latestOnDemandRead: onDemandReads.latestOnDemandRead
                  ? {
                      ...onDemandReads.latestOnDemandRead,
                      dateUtc: timezoneService.formatLong(onDemandReads.latestOnDemandRead!.dateUtc)
                    }
                  : null,
                latestScheduledRead: onDemandReads.latestScheduledRead
                  ? {
                      ...onDemandReads.latestScheduledRead,
                      dateUtc: timezoneService.formatLong(onDemandReads.latestScheduledRead!.dateUtc)
                    }
                  : null,
                postApiInProgress: false,
                isLoading: false
              }
            })
          ),
          catchError(() =>
            of(
              OnDemandReadActions.getOnDemandReadsFailure({
                id,
                deviceDeviceUID,
                mtuDeviceUID,
                error: 'error'
              })
            )
          )
        )
      )
    ),
  { functional: true }
);
